var common = {
  'message.error.xml2json': 'Erro ao converter XML para JSON, por favor verifique se o formato XML está correto'
};
export { common as default };
